/**
 * Returns the hostname without the subdomains
 *
 * @param hostNameResult - The hostname extracted from the window object
 */
export default function applicationDomain(hostNameResult: string): string {
  let formattedHostname = '';
  const hostnameParts = hostNameResult.split('.');
  if (hostnameParts.length >= 3) {
    formattedHostname = hostnameParts.slice(1).join('.');
  } else {
    formattedHostname = hostNameResult;
  }

  return formattedHostname;
}
